import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import {customerDownloadContract} from "../../requests/er-thunk";
import { DownloadIcon} from "../../../assets";

// eslint-disable-next-line react/prop-types
const DopDocuments = ({ contract }) => {
  const dispatch = useDispatch();
  const downloadFiles = useCallback(
    (el) => {
      dispatch(customerDownloadContract(el));
    },
    [dispatch]
  );

  return (
    <div
      style={{
        overflow: "auto",
        // width: "100%",
        height: "62vh",
        // paddingLeft: 24,
        // paddingRight: 24,
        margin: 24,
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: 16,
        display: "flex",
        flexWrap: "wrap",
      }}
    >
      {/* eslint-disable-next-line react/prop-types */}
      {contract?.additional?.map((el, idx) => {
        return (
          <div
            key={el}
            style={{
              width: "49%",
              height: 296,
              padding: 16,
              background: "#F1F6FF",
              overflow: "hidden",
              borderRadius: 12,
              outline: "1px #E7E7E7 solid",
              outlineOffset: "-1px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 12,
              display: "inline-flex",
              position: "relative",
            }}
          >
            <div
              style={{
                width: "100%",
                paddingLeft: 16,
                paddingRight: 16,
                paddingTop: 12,
                paddingBottom: 12,
                background: "white",
                borderRadius: 8,
                outline: "1px #E7E7E7 solid",
                outlineOffset: "-1px",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: 4,
                display: "inline-flex",
              }}
            >
              <div
                style={{
                  alignSelf: "stretch",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 12,
                  display: "inline-flex",
                }}
              >
                <div
                  style={{
                    flex: "1 1 0",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    color: "#192233",
                    fontSize: 14,
                    fontFamily: "Manrope",
                    fontWeight: "700",
                    wordWrap: "break-word",
                  }}
                >
                  {el}
                </div>
                <DownloadIcon style={{cursor: "pointer"}} onClick={() => downloadFiles(el)}/>
                {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                {/*<img*/}
                {/*  style={{ cursor: "pointer" }}*/}
                {/*  onClick={() => downloadFiles(el)}*/}
                {/*  src={downloadIcon}*/}
                {/*  alt={" "}*/}
                {/*/>*/}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DopDocuments;
